import lazyWithPreload from 'react-lazy-with-preload';
export const lazy = lazyWithPreload;
